import type { RouteLocationNormalized } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useNotificationStore } from '@/stores/notification'
import { setCookie } from '@/services/cookies'
import { MY_ROUTES } from '@/router/routes.enum'

export const requireReservationsEnabled = () => {
  if (import.meta.env.VITE_FEATURES_RESERVATIONS !== 'true') {
    return { name: MY_ROUTES.ORDERS }
  }
}

export const requireAuthenticated = async (to: RouteLocationNormalized) => {
  const authStore = useAuthStore()

  if (!authStore.isAuthenticated) {
    if ((to.name == MY_ROUTES.ORDERS && !to.redirectedFrom) || to.name != MY_ROUTES.ORDERS) {
      setCookie('signInExpired', 'true')
    }
    return { name: MY_ROUTES.SIGN_IN }
  }
}

export const redirectIfAuthenticated = (to: RouteLocationNormalized) => {
  const authStore = useAuthStore()
  const notificationStore = useNotificationStore()

  if (authStore.isAuthenticated) {
    if (to.meta.redirectNotification) {
      notificationStore.notifyWarning(to.meta.redirectNotification as string)
    }
    return { name: MY_ROUTES.ORDERS }
  }
}
